// ABOUTME: Top-bar environment badge with a reroute link, plus a persistent caution banner on Production/Unknown.
// ABOUTME: Makes it unmistakable which deployment CS is viewing and lets them switch to the other one.
import { environment, altEnvUrl } from '../config';
import { ENVIRONMENTS } from '../environment';
import './EnvironmentIndicator.css';

export function EnvironmentIndicator() {
  return (
    <div className="environment-indicator">
      <span
        data-testid="environment-badge"
        className={`environment-badge environment-badge-${environment}`}
      >
        {ENVIRONMENTS[environment].label}
      </span>
      {altEnvUrl && (
        <a
          className="environment-switch"
          href={altEnvUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          Switch environment
        </a>
      )}
    </div>
  );
}

export function EnvironmentBanner() {
  const banner = ENVIRONMENTS[environment].banner;
  if (!banner) return null;
  return (
    <div
      role="alert"
      className={`environment-warning environment-warning-${environment}`}
    >
      {banner}
    </div>
  );
}
